import * as React from "react";
import {
  GridColumnMenuFilter,
  GridColumnMenuFilterUIProps,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { CustomFilterUiRadioButton } from "./CustomFilterUiRadioButton";

export function InScopeOutOfScopeColumnMenu(props: GridColumnMenuProps) {
  const filterUi = (filterUiProps: GridColumnMenuFilterUIProps) => (
    <CustomFilterUiRadioButton
      {...filterUiProps}
      values={[
        {
          label: "In Scope",
          value: true,
        },
        {
          label: "Out of Scope",
          value: false,
        },
      ]}
    />
  );

  return (
    <div>
      <GridColumnMenuFilter {...props} expanded filterUI={filterUi} />
    </div>
  );
}
